'use client';

// Update the import path below to the correct location of useByoidVisitorId
import { useByoidVisitorId } from '@/app/_lib/hooks/useByuidVisitorId';

interface ByoidProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that ensures BYOID_VisitorID cookie is set
 * Use this to wrap pages that require visitor tracking
 */
export const ByoidProvider = ({ children }: ByoidProviderProps) => {
  useByoidVisitorId();

  return <>{children}</>;
};
